import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpsertAccountFlag() {
  const put = usePut(true, "ams");
  const upsertAccountFlag = (accountId: string, key: string, expiryDate?: Date, effectiveDate?: Date) => {
    return put(`/api/proxy/ams/account-service/account/${accountId}/flags/${key}`, {
      AccountFlagExpiryDate: expiryDate
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, key, expiryDate, effectiveDate }: { accountId: string, key: string, expiryDate?: Date, effectiveDate?: Date }) =>
      upsertAccountFlag(accountId, key, expiryDate, effectiveDate),
  });
}
